import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { searchProducts } from '../utils/api';
import ProductGrid from '../components/ProductGrid';
import SectionHeading from '../components/SectionHeading';
import { useCart } from '../context/CartContext';

export default function BrandPage(){
  const { slug } = useParams();
  const { data } = useQuery({ queryKey:['brand', slug], queryFn:()=>searchProducts({ brand: slug, limit: 24 }) });
  const { add } = useCart();
  return (<main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
    <SectionHeading title={`Brand: ${slug}`} />
    <ProductGrid items={data?.items||[]} onAdd={add} />
  </main>);
}
